module.exports = __webpack_public_path__ + "img/vehicle-options-white-lincoln.29a994e8.png";